import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFileTypeFold = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 7.2 7.2"
    fill="none"
    {...props}
  >
    <path
      d="M0 4.89844V0L7.2 7.2H2.41025C0.254878 7.2 0 5.68285 0 4.89844Z"
      fill="#fff"
      fillOpacity={0.3}
    />
  </svg>
);
export default SvgFileTypeFold;
